import { CHAT_DIRECT_INDEX } from "../../db/chat";
import { BaseDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Direct Index Service (for 1-1 chat)
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatDirectIndexService extends BaseDatabaseService<string> {
    protected getBasePath(): string {
        return CHAT_DIRECT_INDEX;
    }

    /** The id of the database to provide to functions get/create/update/delete */
    public getEntityId(userId1: string, userId2: string) {
        return [userId1, userId2].sort().join("_");
    }

    async getChatDirectIndex(userId1: string, userId2: string): Promise<string | null> {
        return this.get(this.getEntityId(userId1, userId2))
    }

    async createChatDirectIndex(
        userId1: string, userId2: string, channelId: string
    ): Promise<string> {
        return this.create(channelId, this.getEntityId(userId1, userId2));
    }

    async updateChatDirectIndex(
        userId1: string, userId2: string, channelId: string
    ): Promise<void> {
        return this.update(this.getEntityId(userId1, userId2), channelId);
    }

    async deleteChatDirectIndex(userId1: string, userId2: string): Promise<void> {
        return this.delete(this.getEntityId(userId1, userId2));
    }
}
